module.exports = __webpack_public_path__ + "img/logo_mtca.f85f58ac.png";